import React, { SVGProps } from 'react';

const SvgRealEstate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="173"
    height="82"
    viewBox="0 0 173 82"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <g stroke="#080808">
        <g transform="translate(-192 -1708) translate(192.326 1709.5)">
          <path d="M64.713 49.82H80.024V79.111H64.713z"/>

          <path
            strokeLinecap="square"
            d="M11.786 78.447L11.786 34.175M157.805 78.447L157.805 34.175M28.097 78.443L28.097 24.873M11.533 79.476L157.552 78.699M42.854 78.447L42.854 16.327M80.135 40.388L80.135 21.748M97.223 40.388L97.223 26.408M114.31 40.388L114.31 31.845"
          />

          <path
            strokeLinecap="round"
            d="M131.398 40.388L131.398 36.505"
          />

          <path d="M0 40.524L64.601 3.883 171.572 38.447"/>

          <path d="M0 36.64L64.601 0 171.572 34.563"/>

          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M64.601 40.524L64.601 16.327 145.468 40.524z"
          />

          <path d="M114.31 16.327L114.31 7.554 131.398 7.554 131.398 21.59"/>

          <circle
            cx="75.864"
            cy="65.631"
            r="1.053"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgRealEstate;
